(function($){
    $(document).ready(function() {
        function externalSectionAlignment() {
            var $section = $('.js-external-section');
            var cellWidth = $section.find('.js-external-content').width();
            var difference = ($(window).width()-$('.container').width())/2;
            var $content = $section.find('.js-content');
            if(window.innerWidth > 1024) {
                $content.css('width',cellWidth-difference + 'px');
            } else {
                $content.css('width',100 + '%');
            }
        }

        externalSectionAlignment();

        $(window).resize(function() {
            externalSectionAlignment();
        });
    });
})(jQuery);
